// Compulsory props : selectedItem, itemsList, onChangeHandler

import React, { useState } from 'react'
import Delete from '../assets/deleteIcon.svg';
import MenuDark from '../assets/MenuDark.png';
import Rename from '../assets/edit.png';
import Duplicate from '../assets/copy.png';
import Manage from '../assets/manage.png';
import Export from '../assets/Export.png';
import Download from '../assets/Download.png'
import Tippy from '@tippyjs/react';
import { OptionMenu } from '../Components/Helper';
//Delete Menu icon for grid view

export const DeleteComponentGrid = (props) => {
  const [open, setOpen] = useState(false)
  let fontColor = props.fontColor ? props.fontColor : "#3c3c3c" //Options font color

  return (

    <>
      <Tippy
        visible={open}
        onClickOutside={() => setOpen(false)}
        animation={false}
        interactive
        onShown={(instance) => {
          document.querySelector('[data-tippy-root]').addEventListener('click', event => {
            instance.hide();
            setOpen(false)
          })
        }}
        onShow={instance => {
          const el = document.querySelector(".scroll-container")
          if (el)
            el.addEventListener('scroll', event => {
              instance.hide()
              setOpen(false)
            })
        }}
        className='tippy-menu'
        arrow={false}
        offset={[-40, 0]}
        content={
          <div size="sm" title="" className="custom-dropdown-dashboard">
            {props.canManage ?
              <div eventKey="duplicate" className="dropdown-set-padding-dashboard tippy-menu-hover">
                <div style={{ display: "flex", cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault()
                    props.onClickManage(e)
                    setOpen(false)
                  }}>
                  <img src={Manage} style={{ height: "14px" }} />
                  <div style={{ marginLeft: '7px', color: fontColor }}>Manage</div>
                </div>
              </div>
              : <></>}
            {props.canExport ?
              <div eventKey="rename" className="dropdown-set-padding-dashboard tippy-menu-hover">
                <div style={{ display: "flex", cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault()
                    props.onclickExport(e)
                    setOpen(false)
                  }}>
                  <img src={Export} style={{ height: "14px" }} />
                  <div style={{ marginLeft: '7px', color: fontColor }}>Export</div>
                </div>
              </div> : <></>}

            {props.canRename ?
              <div eventKey="rename" className="dropdown-set-padding-dashboard tippy-menu-hover">
                <div style={{ display: "flex", cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault()
                    props.onClickRename(e)
                    setOpen(false)
                  }}>
                  <img src={Rename} style={{ height: "14px" }} />
                  <div style={{ marginLeft: '7px', color: fontColor }}>Rename</div>
                </div>
              </div> : <></>}

            {props.canDuplicate ?
              <div eventKey="duplicate" className="dropdown-set-padding-dashboard tippy-menu-hover">
                <div style={{ display: "flex", cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault()
                    props.onclickDuplicate(e)
                    setOpen(false)
                  }}>
                  <img src={Duplicate} style={{ height: "14px" }} />
                  <div style={{ marginLeft: '7px', color: fontColor }}>Duplicate</div>
                </div>
              </div>
              : <></>}

            {props.canDownload ?
              <div eventKey="download" className="dropdown-set-padding-dashboard tippy-menu-hover">
                <div style={{ display: "flex", cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault()
                    props.onClickDownload(e)
                    setOpen(false)
                  }}>
                  <img src={Download} style={{ height: "14px" }} />
                  <div style={{ marginLeft: '7px', color: fontColor }}>Download</div>
                </div>
              </div>
              : <></>}

            

            <div eventKey="delete" className="dropdown-set-padding-dashboard tippy-menu-hover">
              <div style={{ display: "flex", cursor: props.disableDelete ? 'not-allowed' : 'pointer', opacity: props.disableDelete ? 0.5 : undefined }}
                onClick={(e) => {
                  if (!props.disableDelete) {
                    e.preventDefault()
                    props.onClickDelete(e)
                    setOpen(false)
                  }
                }}>
                <img src={Delete} style={{ height: "16px" }} />
                <div style={{ marginLeft: '7px', color: fontColor }}>Delete</div>
              </div>
            </div>

          </div>
        }
      >
        <div style={{
          position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer", ...props.style
        }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(prev => !prev) }} >
          <img src={MenuDark} style={{ width: "100%", heigth: "100%" }} />
        </div>
      </Tippy>

    </>
  )
}

// Delete Menu icon for table view
export const DeleteComponentTable = (props) => {
  const [open, setOpen] = useState(false)
  let fontColor = props.fontColor ? props.fontColor : "#3c3c3c" //Options font color

  return (
    <>
      <Tippy
        visible={open}
        onClickOutside={() => setOpen(false)}
        animation={false}
        interactive
        onShown={(instance) => {
          document.querySelector('[data-tippy-root]').addEventListener('click', event => {
            instance.hide();
            setOpen(false)
          })
        }}
        onShow={instance => {
          const el = document.querySelector(".scroll-container")
          if (el)
            el.addEventListener('scroll', event => {
              instance.hide()
              setOpen(false)
            })
        }}
        className='tippy'
        arrow={false}
        offset={[-10, -10]}
        content={
          <OptionMenu
            optionsStyles={{ width: "100px" }}
            isLeft
            onClickDelete={props.onClickDelete ? (e) => {
              if (!props.disableDelete) {
                e.preventDefault()
                e.stopPropagation()
                props.onClickDelete(e)
                setOpen(false)
              }
            } : null}
            onClickManage={props.onClickManage ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickManage()
              setOpen(false)
            } : null}
            onClickDownload={props.onClickDownload ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickDownload(e)
              setOpen(false)
            } : null}
            onClickEdit={props.onClickEdit ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickEdit()
              setOpen(false)
            } : null}
            onClickDuplicate={props.onClickDuplicate ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickRename(e)
              setOpen(false)
            } : null}
            onClickRename={props.onClickRename ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickDownload(e)
              setOpen(false)
            } : null}
            onClickCall={props.onClickCall ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              props.onClickCall(e)
              setOpen(false)
            } : null}
          />
        }
      >
        <div style={{
          position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer", ...props.style
        }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(prev => !prev) }} >
          <img src={MenuDark} style={{ width: "100%", heigth: "100%" }} />
        </div>
      </Tippy>

    </>
  )
}